import { lazy } from 'react';

const WarehousesPage = lazy(() => import('../pages/Warehouses.page'));
const WarehouseInventoryPage = lazy(() => import('../pages/WarehouseInventory.page'));
const CreateInventoryPage = lazy(() => import('../pages/CreateInventory.page'));
const WarehouseMovementReportPage = lazy(() => import('../pages/WarehouseMovementReport.page'));
const ProductTransferReportPage = lazy(() => import('../pages/ProductTransferReport.page'));
const WarehouseTransfersPage = lazy(() => import('../pages/WarehouseTransfers.page'));
const FullPartialTransferPage = lazy(() => import('../pages/FullPartialTransfer.page'));
const SpecificQuantitiesTransferPage = lazy(
    () => import('../pages/SpecificQuantitiesTransfer.page'),
);

const WarehousesRoutes = [
    {
        path: '/warehouses',
        element: <WarehousesPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/warehouse-inventory',
        element: <WarehouseInventoryPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/warehouse-inventory/add',
        element: <CreateInventoryPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/warehouse-movements',
        element: <WarehouseMovementReportPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/product-transfers',
        element: <ProductTransferReportPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/warehouse-transfers',
        element: <WarehouseTransfersPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/warehouse-transfers/full',
        element: <FullPartialTransferPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/warehouse-transfers/specific',
        element: <SpecificQuantitiesTransferPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { WarehousesRoutes };
